import { ref, Ref } from 'vue'

type UseAsyncFunctionOptions = { error?: Ref<Error | undefined> }
export function useAsyncFunction<F extends (...args: never[]) => Promise<unknown>>(
  fn: F,
  options: UseAsyncFunctionOptions | undefined = undefined,
) {
  const isProcessing = ref(false)
  const error = options?.error ?? ref<Error | undefined>()

  async function wrapper(...args: Parameters<F>): Promise<Awaited<ReturnType<F>>> {
    isProcessing.value = true
    error.value = undefined
    try {
      return (await fn(...args)) as Awaited<ReturnType<F>>
    } catch (e) {
      if (e instanceof Error) {
        error.value = e
      } else {
        error.value = new Error(String(e))
      }
      throw error.value
    } finally {
      isProcessing.value = false
    }
  }

  return { fn: wrapper, error, isProcessing }
}
